export default {"src":"/_next/static/media/corporate-benefits.0549c182.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};